import React from 'react';
import CampaignCreator from './CampaignCreator';

interface Campaign {
  id: number;
  name: string;
  subject: string;
  content_html: string;
  content_text: string;
  segment_id?: number;
  segment_name?: string;
  approval_status: string;
  publish_status: string;
}

interface CampaignEditorProps {
  campaign: Campaign;
  onSave: (result: { campaigns_created: number; campaign_ids: number[] }) => void;
  onCancel: () => void;
}

const CampaignEditor: React.FC<CampaignEditorProps> = ({ campaign, onSave, onCancel }) => {
  // Check if campaign can be edited - allow drafts and rejected campaigns
  const canEdit = campaign.approval_status === 'draft' || campaign.approval_status === 'rejected';
  
  if (!canEdit) {
    return (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Cannot Edit Campaign</h3>
          <p className="text-sm text-gray-600 mb-6">
            This campaign cannot be edited because it has been approved or is already published. Only draft and rejected campaigns can be edited.
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Current status: <span className="font-medium">{campaign.approval_status}</span>
            {campaign.publish_status !== 'ready' && (
              <>, {campaign.publish_status}</>
            )}
          </p>
          <div className="flex justify-end">
            <button
              onClick={onCancel}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Use CampaignCreator for editing
  return (
    <CampaignCreator
      campaign={campaign}
      onSave={onSave}
      onCancel={onCancel}
    />
  );
};

export default CampaignEditor;